/**
 * Tiny external store for the waveform playhead. Lets the composer subscribe
 * to time changes without re-rendering the dialog or the thread list on every
 * playback tick.
 */
export interface TimeSource {
  get: () => number;
  set: (ms: number) => void;
  subscribe: (listener: () => void) => () => void;
}

export function createTimeSource(initialMs = 0): TimeSource {
  let value = initialMs;
  const listeners = new Set<() => void>();
  return {
    get: () => value,
    set: (ms) => {
      if (ms === value) return;
      value = ms;
      listeners.forEach((l) => l());
    },
    subscribe: (listener) => {
      listeners.add(listener);
      return () => {
        listeners.delete(listener);
      };
    },
  };
}
